import { ReactNode } from 'react';

import { cn } from '@app/shared/utils/common';

interface ProgressBadgeProps {
  displayBorderLeft?: boolean;
  displayBorderRight?: boolean;
  children: ReactNode;
}

export function ProgressBadge({
  displayBorderLeft = false,
  displayBorderRight = false,
  children,
}: ProgressBadgeProps) {
  return (
    <span
      className={cn(
        'rounded-[5px] border-y-[0.5px] px-1.5 py-1 text-[11px] font-bold leading-[1.2] text-foreground backdrop-blur-lg',
        'border-home-card-border bg-home-progress-badge-gradient',
        displayBorderLeft && 'border-l-[0.5px]',
        displayBorderRight && 'border-r-[0.5px]'
      )}
    >
      {children}
    </span>
  );
}
